import { OG_IMAGE } from './site';

export const LASTMOD = '2026-10-05';

export const ROUTES = [
  {
    path: '/',
    title: 'Air Conditioning & Building Services Havering & Essex | Fallow',
    description:
      'Fallow Building Services: air conditioning installation, extensions, loft conversions and roofing across Havering and Essex. CIS-registered. Free survey. Call 0203 576 5962.',
    h1: 'Air conditioning and building services for Havering and Essex',
    crumb: 'Home',
  },
  {
    path: '/air-conditioning',
    title: 'Air Conditioning Installation Rainham & Havering | Fallow',
    description:
      'Air conditioning matched to your home and budget, with leading brands including Daikin and Mitsubishi Electric. Quote within 1 hour of survey. Call 0203 576 5962.',
    h1: 'Air Conditioning Installation in Rainham & Havering',
    service: 'Air conditioning installation',
    crumb: 'Air Conditioning',
  },
  {
    path: '/building-services',
    title: 'Building Services Havering & Essex | Extensions, Lofts, Roofing | Fallow',
    description:
      'Extensions, loft conversions, bathrooms, kitchens, roofing and renovations across Havering & Essex. The building work behind better air conditioning. Fixed prices, CIS-registered. Call 0203 576 5962.',
    h1: 'Building Services in Havering & Essex',
    crumb: 'Building Services',
  },
  {
    path: '/property-services',
    title: 'Property Services Havering | Maintenance, Management & AC Servicing | Fallow',
    description:
      'Planned & reactive property maintenance, landlord property management, and air conditioning servicing across Havering & East London. CIS-registered, 4-hour emergency response. Call 0203 576 5962.',
    h1: 'Property Services in Havering & East London',
    crumb: 'Property Services',
  },
  {
    path: '/extensions',
    title: 'Home Extensions Havering & Romford | Fallow',
    description:
      'Single and double-storey extensions, side returns and wraparounds across Havering. Planning managed, written quotes. Free survey: 0203 576 5962.',
    h1: 'Home Extensions in Havering & Romford',
    service: 'Home extensions',
    crumb: 'Extensions',
  },
  {
    path: '/loft-conversions',
    title: 'Loft Conversions Romford & Havering | Fallow',
    description:
      'Dormer, hip-to-gable, Velux and mansard loft conversions in Romford and Havering. Permitted development handled. Free survey: 0203 576 5962.',
    h1: 'Loft Conversions in Romford and Havering',
    service: 'Loft conversions',
    crumb: 'Loft conversions',
  },
  {
    path: '/home-renovations',
    title: 'Home Renovations Essex | Fallow Building Services',
    description:
      'Full home renovations and refurbishments across Essex and East London. One dedicated point of contact and written quotes. Call 0203 576 5962.',
    h1: 'Home Renovations in Havering & Essex',
    service: 'Home renovations',
    crumb: 'Home renovations',
  },
  {
    path: '/kitchen-refurbishments',
    title: 'Kitchen Refurbishments Havering | Fallow',
    description:
      'Kitchen fit-outs and refurbishments in Romford, Hornchurch and Havering. Design to handover, written price. Free survey: 0203 576 5962.',
    h1: 'Kitchen Refurbishments in Havering & Romford',
    service: 'Kitchen refurbishments',
    crumb: 'Kitchens',
  },
  {
    path: '/bathroom-refurbishments',
    title: 'Bathroom Refurbishments Havering | Fallow',
    description:
      'Bathroom installations and refurbishments across Havering and Essex. Fully insured, CIS-registered contractor. Call 0203 576 5962.',
    h1: 'Bathroom Renovation & Refurbishment in Havering',
    service: 'Bathroom refurbishments',
    crumb: 'Bathrooms',
  },
  {
    path: '/roofing',
    title: 'Roofers Havering & Romford | Fallow Building Services',
    description:
      'Pitched and flat roofing, EPDM, GRP, repairs and emergency call-out across Havering. Direct employed roofing team. Call 0203 576 5962.',
    h1: 'Roofing Contractors in Havering & Romford',
    service: 'Roofing',
    crumb: 'Roofing',
  },
  {
    path: '/maintenance',
    title: 'Property Maintenance Essex | Fallow Building Services',
    description:
      'Planned and reactive maintenance for property managers, care homes and landlords. Emergency response, CIS-registered. Call 0203 576 5962.',
    h1: 'Property Maintenance in Essex & East London',
    service: 'Property maintenance',
    crumb: 'Maintenance',
  },
  {
    path: '/property-management',
    title: 'Property Maintenance Contractors | Fallow',
    description:
      'Building fabric maintenance under one monthly invoice for agents, landlords and housing associations across Essex and East London.',
    h1: 'Property Management in Havering & East London',
    service: 'Property management',
    crumb: 'Property management',
  },
  {
    path: '/porches',
    title: 'Porch Builders Havering | Fallow Building Services',
    description:
      'Porch design and construction across Romford and Havering. Permitted development advice and written quotes. Call 0203 576 5962.',
    h1: 'Expert Porch Installation Across Havering & Essex',
    service: 'Porch building',
    crumb: 'Porches',
  },
  {
    path: '/outbuildings',
    title: 'Outbuildings & Garden Rooms Essex | Fallow',
    description:
      'Garden rooms, outbuildings and garages built across Havering and Essex. Free site survey, written quote. Call 0203 576 5962.',
    h1: 'Bespoke Garden Rooms & Outbuildings Across Havering & Essex',
    service: 'Outbuildings and garden rooms',
    crumb: 'Outbuildings',
  },
  {
    path: '/havering',
    title: 'Builder in Havering | Fallow Building Services',
    description:
      'Local building contractor based in Rainham, Havering. Extensions, lofts, roofing and maintenance across RM postcodes. Call 0203 576 5962.',
    h1: 'Building Services in Havering',
    crumb: 'Havering',
  },
  {
    path: '/romford',
    title: 'Building Services Romford | Fallow Building Services',
    description:
      'Building contractor in Romford RM1 to RM7. 1930s housing, Havering Council planning experience. Free site survey: 0203 576 5962.',
    h1: 'Building Services in Romford',
    crumb: 'Romford',
  },
  {
    path: '/about',
    title: 'About Fallow Building Services | Contractor Essex',
    description:
      'Meet Fallow Building Services. CIS-registered builder serving Havering and Essex, with written quotes and one point of contact on every job.',
    h1: 'About Fallow Building Services',
    crumb: 'About',
  },
  {
    path: '/contact',
    title: 'Contact Fallow Building Services | Free Site Survey',
    description:
      'Contact Fallow Building Services for a free site survey. Call 0203 576 5962, WhatsApp or email. Rainham, Essex, RM13 7BD.',
    h1: 'Contact Fallow Building Services',
    crumb: 'Contact',
  },
];

export function routeMeta(path) {
  return ROUTES.find((route) => route.path === path) || ROUTES[0];
}

export function openGraph(meta) {
  const url =
    meta.path === '/'
      ? 'https://fallowbuildingservices.co.uk/'
      : `https://fallowbuildingservices.co.uk${meta.path}`;
  return {
    title: meta.title,
    description: meta.description,
    url,
    image: OG_IMAGE,
  };
}
